import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { SelectOptionModel } from '../../src/typings/api';
import { IAttributesExceptions } from '../../src/typings/models';
import { IUtilities } from '../../src/typings/services';

@Injectable({
    providedIn: 'root'
})
export class Utilities implements IUtilities {
    public static $name = 'utilities';

    private static charBank: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyx0123456789';

    /**
     * A helper for the following case:
     * 1. An empty object is passed into a directive/component via scope/bindings
     * 2. The object is modified within the directive/component
     * 3. An undo function is called from the outer scope which the original empty object is attached to
     * 4. A watcher in the directive/component is waiting to detect a change
     * Normally, the watcher will not fire for an empty object --
     * this function is used to add random data to it so that angular knows there is a difference.
     */
    public addGarbageData(obj: any) {
        if (_.isUndefined(obj)) {
            // tslint:disable-next-line: no-console
            console.warn('addGarbageData called with undefined obj');
            return;
        }

        let length: number = 5;

        // Generate a random string to use as garbage
        let random = this.getRandomString(length);

        // Make sure it doesn't already exist, very low chance...
        while (random in obj) {
            random = this.getRandomString(length);
        }

        obj[random] = 'garbage';
    }

    public addMissingProperties(source: any, defaults: any) {
        for (var p in defaults) {
            if (!defaults.hasOwnProperty(p)) {
                continue;
            }

            if (!source.hasOwnProperty(p)) {
                source[p] = defaults[p];
            }
        }
    }

    public copyAllAttributes(element: angular.IAugmentedJQuery, attrs: angular.IAttributes) {
        for (let attr in attrs.$attr) {
            element.attr(attrs.$attr[attr], attrs[attr]); // Buffalo buffalo buffalo buffalo buffalo buffalo buffalo buffalo
        }
    }

    public copyAllAttributesWithExceptions(
        element: angular.IAugmentedJQuery,
        attrs: angular.IAttributes,
        exceptions: IAttributesExceptions[]
    ) {
        for (let attr in attrs.$attr) {
            let attrName = attrs.$attr[attr];

            if (!this.isException(attrName, exceptions)) {
                element.attr(attrName, attrs[attr]);
            }
        }
    }

    public getRandomString(length: number) {
        return _.sampleSize(Utilities.charBank, length).join('');
    }

    public getSelectOptionByValue(options: SelectOptionModel[], value: any) {
        return _.find(options, (option: SelectOptionModel) => {
            return option.value === value;
        });
    }

    public hasProperties(obj: any): boolean {
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                 return true;
            }
        }
        return false;
    }

    public objectToAttributes(obj: any): string {
        var result: string = ' ';

        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                result += _.kebabCase(property) + '="' + obj[property] + '"';
            }
        }

        return result;
    }

    private isException(attrName: string, exceptions: IAttributesExceptions[]) {
        return exceptions.some((exception: IAttributesExceptions) => {
            /* Method should ONLY EVER be a String.prototype method that returns a boolean --
             * see IAttributeExceptions definition for currently accepted methods */
            if (exception.method && _.isFunction(attrName[exception.method])) {
                return attrName[exception.method](exception.name);
            } else {
                return attrName.indexOf(exception.name) > -1;
            }
        });
    }
}
